import { createI18n } from 'vue-i18n';

function loadLocaleMessages() {
  const locales = require.context('./lang', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const setDateTimeFormats = {
  short: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  },
  long: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long',
    hour: 'numeric',
    minute: 'numeric',
  },
};

const dateTimeFormats = {
  it: setDateTimeFormats,
  fr: setDateTimeFormats,
  en: setDateTimeFormats,
  es: setDateTimeFormats,
  de: setDateTimeFormats,
  pt: setDateTimeFormats,
  'en-GB': setDateTimeFormats,
};

function getBaseLocale() {
  const locale = navigator.language || process.env.VUE_APP_I18N_LOCALE || 'en';
  return locale.split('-')[0]; // Extracts "en" from "en-US", che sarebbe il formato che "navigator.language" restituisce
}

export default createI18n({
  legacy: false,
  locale: getBaseLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
  dateTimeFormats,
});